const UploadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M480 352h-96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32v96c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64v-96c0-17.7-14.3-32-32-32zM278.6 41.4l112 112c9.2 9.2 10.7 23.1 4.6 34.3s-16.9 18.3-29.2 18.3H320V320c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V206H146c-12.3 0-23.4-7.1-29.2-18.3s-4.6-25.1 4.6-34.3l112-112c12.5-12.5 32.8-12.5 45.3 0z" />
  </svg>
);

export default UploadIcon;
